import React, { useState, useEffect, useRef, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';

import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText,
    ContentTextarea,
    DialogCancel,
    DialogConfirm,
} from './styles';

const mc = new MessageCenter();
const fitinsurApi = new FitinsurAPI();

export default function ModalConfirmDelete({ show, onModalClose, onConfirm }) {
    const [visible, setVisible] = useState(show);

    const authContext = useContext(GlobalAuthContext);
    const myRef = useRef();

    useEffect(() => {
        setVisible(show);
    }, [show]);

    const handleConfirm = () => {
        onConfirm && onConfirm()
        onModalClose && onModalClose()
    }

    return (
        <Dialog canShow={visible} >
            <DialogBody ref={myRef}>
                <DialogIcon pink={'exclamation'}>
                    <FontAwesomeIcon icon={['fas', 'exclamation']}></FontAwesomeIcon>
                    <DialogText>Atenção</DialogText>
                </DialogIcon>
                <ContentTextarea>
                    <p>
                        Você Tem certeza de que deseja excluir este registro?
                    </p>
                    <br />
                    <DialogCancel onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onModalClose()
                    }}>CANCELAR
                    </DialogCancel>

                    <DialogConfirm onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleConfirm();
                    }}>CONFIRMAR</DialogConfirm>
                </ContentTextarea>
            </DialogBody>
        </Dialog>

    );
}